exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trend-navigation .link[data-v-6cf81936]{color:#3b3b3a;line-height:2.8125rem}", ""]);

